module.exports = __webpack_public_path__ + "static/media/temperature-hot.7f61c174.svg";